<template lang="pug">
	.creative-create-playable-from-template(v-if="showed")
		.card
			.card-header
				span Create new creative from template
			.card-body.collapse.show
				.playables
					.playable-container(v-for="template in templates" :class="{selected: template.codename === selectedTemplateCodename, hidden: template.active === 2}" @click="select(template)")
						.preview(:style="{backgroundImage: `url(/Images/Icons/Playables/${template.codename.replace(':', '-')}.png)`}")
						span.title {{template.title}}
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="button" v-on:click="createFromTemplate()" :class="{disabled: !selectedTemplateCodename, enabled: !!selectedTemplateCodename}") Create from selected template
						button.btn.btn-warning(v-if="Access.check('playable-templates-edit')" type="button" v-on:click="cloneRepository()") Add new template from git
						//button.btn.btn-primary(type="button" v-on:click="request()") Request custom playable ad
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'
	import { Monitoring } 		from './../../services/Monitoring'

	export default {
		name: "PlayableCreateFromTemplate",
		mixins: [Screen],
		screen: {
			events: {
				"Show PlayableCreateFromTemplate": function() {

					this.showed = true;
					this.templates = _.orderBy(_.filter(Metadata.TemplatePlayables, {active: 1}), 'priority');
					this.selectedTemplateCodename = '';

				}
			}
		},
		data() {

			this.templates = [];

			return {
				showed: false,
				selectedTemplateCodename: ''
			};

		},
		methods: {
			collectData() {


			},
			select(template) {

				this.selectedTemplateCodename = template.codename;

				this.$nextTick(() => {

					Broadcast.call("Selected Playable Template Changed");

				});

			},
			createFromTemplate() {

				if (!this.selectedTemplateCodename) return;

				Server.sendToSocket({
					CreateCreative: {
						type: 'playable',
						templateCodename: this.selectedTemplateCodename,
						publisherId: Publisher.SelectedPublisher.id
					}
				});

				Broadcast.call("Playable From Template Creating");

				this.hide();

			},
			cloneRepository() {

				if (Monitoring.getChannelState('clone-template') !== 'done') {

					Broadcast.call("Show MonitoringLog", ["clone-template"]);

				} else {

					Broadcast.call("Show CloneTemplateRepository");

				}

				this.hide();

			},
			request() {

				Broadcast.call("Show PlayableCreateRequest");

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.creative-create-playable-from-template
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 750px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 500px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.playables
				display: flex
				flex-wrap: wrap
				justify-content: space-around
				align-items: center
				max-height: 360px
				overflow-y: auto

				.playable-container
					display: flex
					flex-direction: column
					align-items: center
					width: 200px
					margin: 10px
					cursor: pointer
					text-align: center
					border: 1px solid #4c4f54
					border-radius: 5px
					box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
					background-color: #343b41

					&.hidden
						opacity: 0.3

					&.selected
						border-color: #e1a82d

					.preview
						display: block
						width: 200px
						height: 200px
						margin: 10px
						background-size: contain
						background-repeat: no-repeat
						background-position: center

					.title
						margin-bottom: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.btn-primary
				white-space: nowrap
				margin-right: 20px

			.btn-warning
				white-space: nowrap
				margin-right: 20px

			.btn-warning.disabled
				cursor: default
				outline: none

			.btn-warning.disabled:focus-within
				box-shadow: none
				outline: none

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.two-setting-panel
				display: flex
				flex-direction: row
				justify-content: space-between

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				justify-content: space-between

				.title
					display: flex
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					flex-direction: row
					align-items: baseline

					.icon-info
						color: #20a8d8
						margin-left: 5px
						font-size: 13px !important

				.form-control
					width: 250px

</style>

